import styled from "styled-components";

export const LobbyHeaderTitleContainerBox = styled.div`
  display: flex;
  width: 100%;

  padding-left: 4rem;
  padding-right: 4rem;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;
